window.PlummeI18n.register('en', {
  "purchaseDocs.removeAll": "Remove all",
  "purchaseDocs.removeOne": "Remove {name} from purchase",
  "purchaseDocs.duplicateTitle": "Possible duplicate posting",
  "purchaseDocs.duplicateHelp": "Check previous purchases before posting. You can still post.",
  "purchaseDocs.sameAttachment": "The same file is attached more than once.",
  "purchaseDocs.sameFile": "The same file is used on voucher {number} · {date}.",
  "purchaseDocs.sameDetails": "Voucher {number} · {date} has the same date and amount.",
  "purchaseFlow.listTitle": "Purchase list",
  "purchaseFlow.pageShown": "This page: {shown} matches",
  "purchaseFlow.pageOf": "This page: {shown} of {total} matches",
  "purchaseFlow.previous": "Previous",
  "purchaseFlow.next": "Next",
  "purchaseFlow.restart": "Refresh from start",
  "purchaseFlow.retry": "Retry",
  "purchaseFlow.pageHelp": "Showing up to 50 purchases per page. Search may leave pages empty; use Next or Previous to continue.",
  "purchaseFlow.closeBeforePaging": "Close the details before changing pages.",
  "purchaseFlow.purchaseCount": "Purchases",
  "purchaseFlow.netPurchases": "Net purchases",
  "purchaseFlow.netPurchasesHelp": "Excl. VAT, after credit notes",
  "purchaseFlow.includingVat": "Incl. VAT",
  "purchaseFlow.credited": "Credited",
  "purchaseFlow.creditable": "Available to credit",
  "purchaseFlow.creditAllocationHelp": "Select the invoice before posting for automatic allocation. Any amount exceeding the unpaid balance remains supplier credit.",
  "err.supplierCredit.invalidAmount": "The credit must be positive and cannot exceed the amount not already credited. Payments do not reduce this limit.",
  "err.purchase.duplicateSupplierDocument": "This document number is already registered for this supplier. Open the existing invoice or credit note.",
  'purchaseFlow.creditNote': 'Credit note',
  "purchaseFlow.negativeWarning": "A negative invoice amount is unusual unless it is a credit note.",
  "purchaseFlow.creditOriginal": "Invoice being credited (optional)",
  "purchaseFlow.standaloneCredit": "No link – credit with the supplier",
  "purchaseFlow.creditLinesRequired": "Use new, negative lines for the credit note. Post it directly; drafts and editing are not supported here.",
  "err.supplierCredit.unsupportedLines": "Use ordinary purchase lines for a supplier credit note; inventory, assets and special VAT treatments require a dedicated correction.",
  'registry.toggleSupplierHelp': 'Suggests Norwegian companies as you type a supplier name or company number.',
  'sup.foreignToggle': 'Foreign supplier',
  'sup.foreignToggleHelp': 'Turn on for suppliers registered in a country other than your business country.',
  'sup.countryCode': 'Country code',
  'sup.countryCodePh': 'E.g. SE or US',
  'sup.countryRequired': 'Enter a two-letter country code for the foreign supplier.',
  'sup.registrationNumber': 'Registration number',
  'sup.registrationNumberPh': 'The supplier’s foreign registration number',
  'sup.vatNumber': 'VAT number',
  'sup.vatNumberPh': 'E.g. SE123456789001',
});
